import { detectPlatform } from '@x1/ui-web/lib/detectPlatform';

import DownloadAppPageDesktop from './Desktop';
import DownloadAppPageMobile from './Mobile';

const DownloadAppPage = () => {
  const isMobile = detectPlatform() === 'iOS' || detectPlatform() === 'Android';
  return isMobile ? <DownloadAppPageMobile /> : <DownloadAppPageDesktop />;
};

export default DownloadAppPage;
